<div class="frequency-view-chart-filters-reset-boundaries-container" *ngIf="displayResetBoundariesButton">
    <button 
        class="frequency-view-chart-filters-reset-boundaries-button"
        (click)="resetBoundaries()"
        ngbTooltip="Zoom to entire frequency range of all rows">
        <i class="fal fa-arrows-h fa-lg cursor-pointer"></i>
    </button>
</div>